import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div style={{
      display:"flex",
      justifyContent: "center",
        
      height: "3px",
      alignItems: "center",
      marginTop: "5px",
      gap: "5px"
      
    }}>
      
     
      <ArrowBackIcon
        style={{
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          color: currentPage === 1 ? "#ccc" : "#000",
          fontSize: "10px"
        }}
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
      />

      
      <Select
        value={currentPage}
        onChange={(e) => onPageChange(Number(e.target.value))}
        style={{ fontSize: "12px",height:"20px" ,}}
      >
        {Array.from({ length: totalPages }, (_, index) => (
          <MenuItem key={index + 1} value={index + 1}>
             {index + 1}
          </MenuItem>
        ))}
      </Select>

      
      <ArrowForwardIcon
        style={{
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          color: currentPage === totalPages ? "#ccc" : "#000",
          fontSize: "10px"
        }}
        onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
      />
    </div>
  );
};

export default Pagination;
